// extracted by mini-css-extract-plugin
module.exports = {"splash":"Splash_splash__1NH3p","splashWrapper":"Splash_splashWrapper__3VFjs"};